import { Component, OnInit } from '@angular/core';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { StaticData } from '../../../helpers/static-data';
import { CrudActions } from '../../../models/general.enum';
import { List, Enumerable } from 'linqts';
import { FormGroup } from '@angular/forms';


@Component({
  selector: 'app-home-external-pqrs',
  templateUrl: './home-external-pqrs.component.html',
  styleUrls: ['./home-external-pqrs.component.scss']
})


export class HomeExternalPqrsComponent extends GeneralFormComponent implements OnInit {

  TipoIdentificacion: any;
  NumeroIdentificacion: any;
  Password: any;
  DivMensaje: any;
  DivMensajeAnonimo: any;
  HeaderLogin: any;
  HeaderLoginForm: any;
  //HeaderLoginAnonimForm: any;
  Enviar: any;
  Anonimo: any;
  OlvidoContrasena: any;
  msnPreregistro: any;
  Meses: any;
  Registro: any;
  FormularPqr: any;
  AnonimaDiv: any;
  Autenticar: any;
  Logged: any = false;
  model: any = { UData: 'marlong@bextsa.com', CData: '', TipoSistema: null, AppKey: null };
  public DatosUsuario: any;
  public DatosIngreso: any;
  public UserAuth: any;

  ngOnInit() {
    debugger;
    if (StaticData.Usuario == null || StaticData.Usuario == undefined) {
      this.LoginPqr();
    }

    if ((StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined) || StaticData.ExternalPqrAnonimo || ((StaticData.ExternalPqrContact == null || StaticData.ExternalPqrContact == undefined) && !StaticData.ContactAuthenticated)) {

      if ((StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined) && StaticData.ContactAuthenticated != false) {
        var obj = this.utility.GetApiModel('ConsultarContactoPqrExterna', this.componentName);

        obj.QueryConfig.Command = 'ConsultarContactoPqrExterna';
        obj.QueryConfig.IsSp = true;
        debugger;
        obj.QueryConfig.Entity = { IdContacto: JSON.parse(StaticData.ExternalPqrContact).IdContacto };
        // obj.QueryConfig.Entity = (esEdicion) ? { IdTablaRetencionDocumental: this.modelo.modelo.IdTablaRetencionDocumental } : this.modelo.modeloCascada;
        // this.baseService.showLoadNotifyType =true;
        this.baseService.Get(obj, null,
          {
            componentName: this.componentName,
            method: 'ConsultarContactoPqrExterna',
            processMessage: 'Verificando datos de usuario...'
          }, 'RContacto')
          .then(data => {
            debugger;
            StaticData.ExternalPqrContact = JSON.stringify(data.Data[0]);

          }).catch(err => {
            this.utility.logger.LogError(err, obj, {
              componentName: this.componentName,
              method: 'ConsultarContactoPqrExterna',
              processMessage: 'Verificando datos de usuario...'
            }, 'RContacto')
          });
      }


      super.ngOnInit();
    }


  }

  public OnInitEnd() {
    debugger;
    this.TipoIdentificacion = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdTipoIdentificacion" });
    this.NumeroIdentificacion = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "NumeroIdentificacion" });
    this.Password = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Contrasena" });
    this.DivMensaje = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivMensajeLogin" });
    this.DivMensajeAnonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivMensajeAnonimo" });
    this.HeaderLogin = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "HeaderLogin" });
    this.HeaderLoginForm = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "HeaderLoginForm" });
    //this.HeaderLoginAnonimForm = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "HeaderLoginAnonimForm" });
    this.Enviar = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Enviar" });
    this.Anonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Anonimo" });
    this.OlvidoContrasena = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "OlvidoContrasena" });
    this.msnPreregistro = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "msnPreregistro" });
    this.Registro = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Registro" });
    this.FormularPqr = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "FormularPqr" });
    this.Meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Dicembre"];
    this.AnonimaDiv = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "AnonimaDiv" });
    this.Autenticar = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Autenticar" });

    if (!StaticData.ContactAuthenticated && StaticData.ExternalPqrContact != null) {
      this.LimpiarSesion();
    }

    var UserData = StaticData.ExternalPqrContact;
    if (UserData != null && UserData != undefined) {
      this.SetDatosAcceso(JSON.parse(UserData));
    }
    /*MANUEL RODRIGUEZ 26092023: Comentado dada la solicitud de la Tarea 1 de la HU PQRS Fase 1 durante el proyecto Ferrocarriles*/
    /*else if (StaticData.ExternalPqrAnonimo) {
      this.ControlesAnonimo();
    }*/

  }

  public LoginPqr() {

    let modeloTemp = this.utility.Clone(this.model);
    modeloTemp.UData = btoa(this.model.UData);
    modeloTemp.AppKey = StaticData.AppKey;
    //modeloTemp.CData = btoa(this.model.CData);
    let obj = this.utility.GetApiModel('LoginPQR', '', CrudActions.None, null, modeloTemp);
    this.baseService.LoginPQR(obj, null,
      { componentName: 'ModalLoginComponent', method: 'LoginPQR', processMessage: 'Procesando credenciales....' },
      'AuthenticationBase', false, true).then(data => {

        debugger;
        if (!data.Data || data.Data.Table === undefined || data.Data.Table[0] === undefined) {
          this.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'El usuario no es valido en el sistema.....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });

          //throw 'El usuario no es valido en el sistema';
          return;
        }
        StaticData.Usuario = data.Data.Table[0];
        StaticData.Usuario.Token = data.Data.Token;

        if (StaticData.Usuario.Activo == false) {
          StaticData.Usuario = null;
          this.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'El usuario no se encuentra activo.....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });


          //throw 'El usuario no se encuentra activo';
          return;
        }
        if (!data.Data.Token) {
          StaticData.Usuario = null;


          this.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'Token Invalido....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });

          //throw 'El usuario no se encuentra activo';
          return;
        }

        //debugger;
        StaticData.Usuario.MenusUsuario = data.Data.Table1;
        StaticData.Usuario.PaginasUsuario = data.Data.Table2;
        StaticData.Usuario.Paginas = data.Data.Table3;
        // CM
        //StaticData.Usuario.ReportesUsuario = data.Data.Table4;


        StaticData.GeneralConfig = data.Data.GeneralConfig;


        if (!StaticData.GeneralConfig.ConfigUI.TiempoMensajesAdicionalModalEnNotifi)
          StaticData.GeneralConfig.ConfigUI.TiempoMensajesAdicionalModalEnNotifi = 500;

        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionError)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionError = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionAlerta)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionAlerta = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionOk)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionOk = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionInfo)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionInfo = 500;

        if (data.Data.ToolBox) {
          StaticData.ToolBox = JSON.parse(data.Data.ToolBox.StringValue);
          StaticData.ToolBox.Id = data.Data.ToolBox.Id;
          StaticData.ToolBox.TipoDato = data.Data.ToolBox.TipoDato;
          StaticData.ToolBox.Name = data.Data.ToolBox.Name;
        }
        StaticData.WorkFlowTaskConfig = data.Data.WorkFlowTaskConfig;
        /* 
                $.each(StaticData.Usuario.PaginasUsuario, function (key, pagina) {
        
                  // > [8, 10]
                  //var camposPaginas = Enumerable.From(data.Data.Table5).Where(function (x) { return x.IdPagina == pagina.IdPagina }).ToArray();
        
                  var paginaConfig = {
                    IdPagina: pagina.IdPagina,
                    Nombre: pagina.Pagina, Config: {}
                  };
                  if(pagina.Configuracion){
        
                  }
        
                  StaticData.ConfigPaginas.push(paginaConfig);
                }); */



        StaticData.Usuario.Rules = data.Data.Rules;

        //CM 
        /*
        $.each(StaticData.Usuario.ReportesUsuario, function (key, reporte) {

          if (reporte.ConfiguracionFiltro && reporte.ConfiguracionFiltro !== null) {
            reporte.ConfigFilter = JSON.parse(reporte.ConfiguracionFiltro);
            let shapes = new List<any>(reporte.ConfigFilter.Shapes);
            reporte.ConfigFilter.Shapes = shapes.Where(x => x.Active == true).ToArray();
            // reporte.ConfigFilter.Shapes = Enumerable.From(reporte.ConfigFilter.Shapes).Where(function (x) { return x.Active == true }).ToArray();
          }
        });
        */





        // let BotonesComoMenu = StaticData.ParametrosGenerales.Where(x=>{return x.Nombre=='BotonesComoMenu' }).FirstOrDefault();
        // StaticData.BotonesComoMenu =(BotonesComoMenu)?BotonesComoMenu.ValorFalsoVerdadero:false;

        let estilosGenerales = (data.Data.Table4 && data.Data.Table4.length > 0) ? new List<any>(data.Data.Table4) : new List<any>([]);
        let estilosPorRole = (data.Data.Table5 && data.Data.Table5.length > 0) ? new List<any>(data.Data.Table5) : new List<any>([]);

        StaticData.ParametrosGenerales = (data.Data.Table6) ? new List<any>(data.Data.Table6) : new List<any>([]);
        /*  let ConfigGeneral = StaticData.ParametrosGenerales.FirstOrDefault(x => { return x.Nombre == 'ConfigGeneral' });
         if (ConfigGeneral) {
           StaticData.ConfigGeneral = JSON.parse(ConfigGeneral);
          
         } */
        //debugger;
        StaticData.RolesUsuariosGrupos = new List<any>(data.Data.Table7);
        StaticData.Carpetas = new List<any>(data.Data.Table8);
        StaticData.AreasEmpresa = new List<any>(data.Data.Table9);
        StaticData.Series = new List<any>(data.Data.Table10);
        StaticData.SubSeries = new List<any>(data.Data.Table11);

        let BotonesComoMenu: string = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'BotonesComoMenu', '');
        StaticData.BotonesComoMenu = false;

        if (BotonesComoMenu &&
          (BotonesComoMenu.toLowerCase() == 'si' ||
            BotonesComoMenu.toLowerCase() == 'ok' ||
            BotonesComoMenu.toLowerCase() == 'yes' ||
            BotonesComoMenu.toLowerCase() == 'true' ||
            BotonesComoMenu.toLowerCase() == '1'))
          StaticData.BotonesComoMenu = true;


        let Tema = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'Tema', '');

        let ColorMenu = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorMenu', 'blue');
        let ColorTitulos = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorTitulos', 'blue');
        let ColorBotonGuardar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonGuardar', 'blue');

        let ColorBotonLimpiar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonLimpiar', 'blue');
        let ColorBotonFiltro = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonFiltro', 'blue');
        let ColorBotonImportar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonImportar', 'blue');
        let ColorBotonExportarExcel = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonExportarExcel', 'blue');
        let ColorBotonExportarCsv = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonExportarCsv', 'blue');
        let ColorBotonRedireccion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonRedireccion', 'blue');
        let ColorBotonBuscar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonBuscar', 'blue');

        let ClassMenu = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassMenu', '');
        //let ClassTitulos =this.GetDatosEstilos(estilosPorRole,estilosGenerales,'ClassTitulos','blue');
        let ClassBotonGuardar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonGuardar', 'btn btn-outline-success');
        let ClassBotonLimpiar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonLimpiar', 'btn btn-outline-info');
        let ClassBotonFiltro = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonFiltro', 'btn btn-outline-info');
        let ClassBotonImportar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonImportar', 'btn btn-outline-info');
        let ClassBotonExportarExcel = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonExportarExcel', 'btn btn-outline-info');
        let ClassBotonExportarCsv = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonExportarCsv', 'btn btn-outline-info');
        let ClassBotonRedireccion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonRedireccion', 'btn btn-outline-info');
        let ClassBotonBuscar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonBuscar', 'btn btn-outline-info');
        let ClassTitulo = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassTitulo', '');


        let ClassContenedorGeneral = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorGeneral', 'container');
        let ClassContenedor = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedor', 'container card');
        let ClassHeader = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassHeader', 'card-header info-color white-text text-center py-4');
        let ClassContenedorForm = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorForm', 'card-body px-lg-5 pt-0');

        let ClassContenedorControlesAdd = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorControlesAdd', '');

        let ClassControles = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassControles', 'md-form');

        let ClassBotonOpcion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonOpcion', 'btn btn-info btn dropdown-toggle');

        let _EstiloTitulo = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloTitulo', 'blue');
        let EstiloTitulo = this.SetStyle(_EstiloTitulo, ColorTitulos, { color: ColorTitulos });
        let _EstiloBotonGuardar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonGuardar', '');
        let EstiloBotonGuardar = this.SetStyle(_EstiloBotonGuardar, ColorBotonGuardar, {
          'background-color': ColorBotonGuardar,
          'border-color': ColorBotonGuardar,
          'cursor': 'pointer'
        });
        let _EstiloBotonLimpiar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonLimpiar', '');
        let EstiloBotonLimpiar = this.SetStyle(_EstiloBotonLimpiar, ColorBotonLimpiar, {
          'background-color': ColorBotonLimpiar,
          'border-color': ColorBotonLimpiar,
          'cursor': 'pointer'
        });

        let _EstiloBotonFiltro = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonFiltro', '');
        let EstiloBotonFiltro = this.SetStyle(_EstiloBotonFiltro, ColorBotonFiltro, {
          'background-color': ColorBotonFiltro,
          'border-color': ColorBotonFiltro,
          'cursor': 'pointer'
        });

        let _EstiloBotonImportar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonImportar', '');
        let EstiloBotonImportar = this.SetStyle(_EstiloBotonImportar, ColorBotonImportar, {
          'background-color': ColorBotonImportar,
          'border-color': ColorBotonImportar,
          'cursor': 'pointer'
        });
        let _EstiloBotonExportarExcel = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonExportarExcel', '');
        let EstiloBotonExportarExcel = this.SetStyle(_EstiloBotonExportarExcel, ColorBotonExportarExcel, {
          'background-color': ColorBotonExportarExcel,
          'border-color': ColorBotonExportarExcel,
          'cursor': 'pointer'
        });
        let _EstiloBotonExportarCsv = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonExportarCsv', '');
        let EstiloBotonExportarCsv = this.SetStyle(_EstiloBotonExportarCsv, ColorBotonExportarCsv, {
          'background-color': ColorBotonExportarCsv,
          'border-color': ColorBotonExportarCsv,
          'cursor': 'pointer'
        });

        let _EstiloBotonRedireccion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonRedireccion', '');
        let EstiloBotonRedireccion = this.SetStyle(_EstiloBotonRedireccion, ColorBotonRedireccion, {
          'background-color': ColorBotonRedireccion,
          'border-color': ColorBotonRedireccion,
          'cursor': 'pointer'
        });

        let _EstiloBotonBuscar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonBuscar', '');
        let EstiloBotonBuscar = this.SetStyle(_EstiloBotonBuscar, ColorBotonBuscar, {
          'background-color': ColorBotonBuscar,
          'border-color': ColorBotonBuscar,
          'cursor': 'pointer'
        });



        let _EstiloContenedorGeneral = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorGeneral', '');
        let EstiloContenedorGeneral = this.SetStyle(_EstiloContenedorGeneral, null, null);

        let _EstiloContenedor = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedor', '');
        let EstiloContenedor = this.SetStyle(_EstiloContenedor, null, null);
        let _EstiloHeader = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloHeader', '');
        let EstiloHeader = this.SetStyle(_EstiloHeader, null, null);
        let _EstiloContenedorForm = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorForm', '');
        let EstiloContenedorForm = this.SetStyle(_EstiloContenedorForm, null, null);


        let _EstiloContenedorControlesAdd = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorControlesAdd', '');
        let EstiloContenedorControlesAdd = this.SetStyle(_EstiloContenedorControlesAdd, null, null);



        let ClassNodos = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodos', '');//'container alert alert-primary'
        let ClassNodosNuevos = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosNuevos', '');
        let ClassNodosEliminados = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosEliminados', '');
        let ClassNodosModificados = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosModificados', '');
        let ClassNodosCambioPadre = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosCambioPadre', '');


        StaticData.Estilos = {
          EstiloBotonGuardar: EstiloBotonGuardar,
          EstiloBotonLimpiar: EstiloBotonLimpiar,
          EstiloBotonFiltro: EstiloBotonFiltro,
          EstiloBotonImportar: EstiloBotonImportar,
          EstiloBotonExportarExcel: EstiloBotonExportarExcel,
          EstiloBotonExportarCsv: EstiloBotonExportarCsv,
          ClassBotonGuardar: ClassBotonGuardar,
          ClassBotonLimpiar: ClassBotonLimpiar,
          ClassBotonFiltro: ClassBotonFiltro,
          ClassBotonImportar: ClassBotonImportar,

          ClassBotonExportarExcel: ClassBotonExportarExcel,
          ClassBotonExportarCsv: ClassBotonExportarCsv,
          ClassControles: ClassControles,
          ClassBotonOpcion: ClassBotonOpcion,
          EstiloTitulo: EstiloTitulo,
          ClassTitulo: ClassTitulo,
          EstiloContenedor: EstiloContenedor,
          ClassContenedor: ClassContenedor,

          EstiloHeader: EstiloHeader,
          ClassHeader: ClassHeader,
          EstiloContenedorForm: EstiloContenedorForm,
          ClassContenedorForm: ClassContenedorForm,
          EstiloContenedorGeneral: EstiloContenedorGeneral,
          ClassContenedorGeneral: ClassContenedorGeneral,
          EstiloContenedorControlesAdd: EstiloContenedorControlesAdd,
          ClassContenedorControlesAdd: ClassContenedorControlesAdd,
          Tema: Tema,
          EstiloBotonRedireccion: EstiloBotonRedireccion,
          ClassBotonRedireccion: ClassBotonRedireccion,
          EstiloBotonBuscar: EstiloBotonBuscar,
          ClassBotonBuscar: ClassBotonBuscar,
          ClassNodos: ClassNodos,
          ClassNodosNuevos: ClassNodosNuevos,
          ClassNodosEliminados: ClassNodosEliminados,
          ClassNodosModificados: ClassNodosModificados,
          ClassNodosCambioPadre: ClassNodosCambioPadre,
          MenuSuperior: {
            'border-bottom': ColorMenu + ' 2px solid'

          },
          Linea: {
            height: '50px', 'border-bottom': ColorMenu + ' 2px solid'

          },



        };

        debugger;
        this.Logged = true;
        super.ngOnInit();

        //this.endEmitter.emit(true);

      }).catch(error => {
        console.log(error);
        this.SetProcesando(false);
        //this.endEmitter.emit(false);

        //this.comunicationService.raiseLoginErrorEvent(error);
      });


  }

  public GetDatosEstilos(estilosPorRole: List<any>, estilosGenerales: List<any>, nombreKey: any, valorPorDefecto: any): any {
    let obj = estilosPorRole.FirstOrDefault(x => x.Nombre == nombreKey);
    if (!obj)
      obj = estilosGenerales.FirstOrDefault(x => x.Nombre == nombreKey);
    if (!obj)
      return valorPorDefecto;
    else
      return obj.Valor;
  }

  public SetStyle(estilos: any, objetoColor: any, valorPorDefecto: any): any {
    let obj = (valorPorDefecto) ? valorPorDefecto : {};
    if (estilos && estilos.split(';').length > 1 && estilos.split(':').length > 1) {
      obj = { color: null };
      if (objetoColor)
        obj.color = objetoColor;
      $.each(estilos.split(';'), function (key, val) {

        obj[val.split(':')[0]] = val.split(':')[1].trim();
      });
    }
    return obj;
  }

  public OnActionEventHandler(event) {
    debugger;
    switch (event.ControlType) {

      case 'Button': {
        switch (event.Name) {
          case 'Enviar': {
            //if (!this.modelo.modelo.Anonimo) {
            if ((this.modelo.modelo.IdTipoIdentificacion != null && this.modelo.modelo.IdTipoIdentificacion != undefined) && (this.modelo.modelo.NumeroIdentificacion != null && this.modelo.modelo.NumeroIdentificacion != undefined) && (this.modelo.modelo.Contrasena != null && this.modelo.modelo.Contrasena != undefined)) {
              this.AutenticateExternalPqrContact();
            }
            else {
              this.utility.VerModalWarning({
                titulo: 'Alerta', descripcion: 'Por favor ingrese sus credenciales para continuar',
                verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
              });
            }

            /*}
            else {
              StaticData.ExternalPqrAnonimo = true;
              this.ControlesAnonimo();
            }*/
            break
          };
          case 'Anonimo': {
            StaticData.ExternalPqrAnonimo = true;
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('HomeExternalPQR', 'ExternalPQRs');
            window.scrollTo(0, 0);
            /*MANUEL RODRIGUEZ 26092023: Comentado dada la solicitud de la Tarea 1 de la HU PQRS Fase 1 durante el proyecto Ferrocarriles*/
            //this.OlvidoContrasena.Hidden = true;
            //this.ControlesAnonimo();
            break
          };
          case 'Autenticar': {
            //this.modelo.modelo.Anonimo = false;
            this.DivMensajeAnonimo.Hidden = true;
            this.TipoIdentificacion.Hidden = false;
            this.NumeroIdentificacion.Hidden = false;
            StaticData.ExternalPqrAnonimo = false;
            this.Password.Hidden = false;
            this.DivMensaje.Hidden = true;
            this.Enviar.Hidden = false;
            this.Anonimo.Hidden = false;
            this.FormularPqr.Hidden = true;
            //this.AnonimaDiv.Hidden = true;
            this.Autenticar.Hidden = true;
            this.OlvidoContrasena.Hidden = false;
            this.HeaderLogin.Hidden = false;
            this.HeaderLoginForm.Hidden = true;
            //this.HeaderLoginAnonimForm.Hidden = true;

            this.SetModelToControls();
            break
          };
          case 'Registro': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('HomeExternalPQR', 'ExternalPQRContact');
            window.scrollTo(0, 0);
            break
          };
          case 'FormularPqr': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('HomeExternalPQR', 'ExternalPQRs');
            window.scrollTo(0, 0);
            break
          };
          case 'ConsultaPQRs': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('HomeExternalPQR', 'ConsultaExternalPQR');
            window.scrollTo(0, 0);
            break
          };
          case 'OlvidoContrasena':
            {
              var CurrentUrl = window.location.href;
              window.location.href = CurrentUrl.replace('HomeExternalPQR', 'RecuperarContrasena');
              window.scrollTo(0, 0);
              break;
            };
          case 'ValidarDocumento':
            {
              var CurrentUrl = window.location.href;
              window.location.href = CurrentUrl.replace('HomeExternalPQR', 'ValidarDocumentoExternalPqrs');
              window.scrollTo(0, 0);
              break;
            };
          case 'GuiaUso': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('HomeExternalPQR', 'GuiaUsoExternalPqrs');
            window.scrollTo(0, 0);
            break;
          };
        }
        break
      };
      case 'CommandButton': {
        if (event.Option.Label == "Responder") {
          if (this.modelo.modelo.IdExpediente == null || this.modelo.modelo.IdExpediente == '') {
            this.utility.VerModalError("La solicitud no posee un expediente asignado");
            return;
          }
        }
        break
      };

    }
    super.OnActionEventHandler(event);
  }

  /*MANUEL RODRIGUEZ 26092023: Comentado dada la solicitud de la Tarea 1 de la HU PQRS Fase 1 durante el proyecto Ferrocarriles*/

  /*public ControlesAnonimo() {
    this.TipoIdentificacion.Hidden = true;
    this.NumeroIdentificacion.Hidden = true;
    this.OlvidoContrasena.Hidden = true;
    this.Password.Hidden = true;
    this.DivMensaje.Hidden = false;
    this.Enviar.Hidden = true;
    this.Anonimo.Hidden = true;
    this.FormularPqr.Hidden = false;
    //this.AnonimaDiv.Hidden = false;
  this.Autenticar.Hidden = false
    this.DivMensaje.Hidden = true;
    this.DivMensajeAnonimo.Hidden = false;
    this.HeaderLoginForm.Hidden = true;
    //his.HeaderLoginAnonimForm.Hidden = false;
    this.HeaderLogin.Hidden = true;
  }*/

  public AutenticateExternalPqrContact() {
    debugger;
    var obj = this.utility.GetApiModel('AutenticarContactoPqrExterna', this.componentName);

    obj.QueryConfig.Command = 'AutenticarContactoPqrExterna';
    obj.QueryConfig.IsSp = true;
    debugger;
    obj.QueryConfig.Entity = { IdTipoIdentificacion: this.modelo.modelo.IdTipoIdentificacion, Identificacion: this.modelo.modelo.NumeroIdentificacion, Password: btoa(this.modelo.modelo.Contrasena) };
    // obj.QueryConfig.Entity = (esEdicion) ? { IdTablaRetencionDocumental: this.modelo.modelo.IdTablaRetencionDocumental } : this.modelo.modeloCascada;
    // this.baseService.showLoadNotifyType =true;
    this.baseService.Get(obj, null,
      {
        componentName: this.componentName,
        method: 'AutenticarContactoPqrExterna',
        processMessage: 'Verificando credenciales de usuario...'
      }, 'RContacto')
      .then(data => {
        debugger;
        if (data.Data[0].Message != null || data.Data[0].Message != undefined) {
          this.utility.VerModalWarning({
            titulo: 'Alerta', descripcion: data.Data[0].Message,
            verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
          }).then(data => { });
        }
        else {
          this.msnPreregistro.Hidden = true;
          StaticData.ExternalPqrContact = JSON.stringify(data.Data[0]);
          this.SetDatosAcceso(JSON.parse(JSON.stringify(data.Data[0])));
        }

      }).catch(err => {
        this.utility.logger.LogError(err, obj, {
          componentName: this.componentName,
          method: 'AutenticarContactoPqrExterna',
          processMessage: 'Verificando credenciales de usuario...'
        }, 'RContacto')
      });
  }

  public SetDatosAcceso(data) {

    this.HeaderLogin.Hidden = true;
    this.HeaderLoginForm.Hidden = false;
    //this.HeaderLoginAnonimForm.Hidden = true;
    this.TipoIdentificacion.Hidden = true;
    this.NumeroIdentificacion.Hidden = true;
    this.Password.Hidden = true;
    this.DivMensaje.Hidden = false;
    this.Enviar.Hidden = true;
    this.Anonimo.Hidden = true;
    this.OlvidoContrasena.Hidden = true;
    this.DatosUsuario = data.IdTipoContacto == 10 ? data.RazonSocial + ', ID ' + data.Identificacion : data.NombreCompleto + ', ID ' + data.Identificacion;
    let FechaIngreso = new Date();
    this.DatosIngreso = 'Fecha de ingreso a las ' + (FechaIngreso.getHours().toString().length == 1 ? '0' + FechaIngreso.getHours() : FechaIngreso.getHours()) + ":" + (FechaIngreso.getMinutes().toString().length == 1 ? '0' + FechaIngreso.getMinutes() : FechaIngreso.getMinutes()) + ', ' + FechaIngreso.getDate() + ' de ' + this.Meses[(FechaIngreso.getMonth())] + ', ' + FechaIngreso.getFullYear();
    this.Registro.Hidden = true;
    this.FormularPqr.Hidden = false;
    //this.AnonimaDiv.Hidden = true;
    this.Autenticar.Hidden = true;
    this.DivMensaje.Hidden = false;
    StaticData.ContactAuthenticated = true;

    this.SetModelToControls();
  }

  public LimpiarSesion() {
    debugger;

    this.modelo.modelo.IdTipoIdentificacion = null;
    this.modelo.modelo.NumeroIdentificacion = '';
    this.modelo.modelo.Contrasena = '';
    StaticData.ExternalPqrContact = null;
    StaticData.ContactAuthenticated = false;
    StaticData.ExternalPqrAnonimo = false;
    //sessionStorage.removeItem('ExternalPqrContact');
    this.HeaderLogin.Hidden = false;
    this.HeaderLoginForm.Hidden = true;
    //this.HeaderLoginAnonimForm.Hidden = true;
    this.TipoIdentificacion.Hidden = false;
    this.NumeroIdentificacion.Hidden = false;
    this.Password.Hidden = false;
    this.DivMensaje.Hidden = true;
    this.Enviar.Hidden = false;
    this.Anonimo.Hidden = false;
    this.msnPreregistro.Hidden = false;
    this.OlvidoContrasena.Hidden = false;
    this.DatosUsuario = null;
    this.DatosIngreso = null;
    this.Registro.Hidden = false;
    this.FormularPqr.Hidden = true;

    this.SetModelToControls();
  }

  SalidaPqrs($event) {
    debugger;
    this.LimpiarSesion();
  }


}
